import { Store } from 'redux';

import { logoutAsync, selectRefreshToken, waitForAccessTokenUpdate } from '@bolteu/redux-session';

import { GlobalAppState } from 'rdx/state';

export const createGatewayHooks = ({ store }: { store: Store<GlobalAppState> }) => {
  return {
    preRequestHook: () => {},
    unauthorisedResponseHook: () => {
      if (!selectRefreshToken(store.getState())) {
        store.dispatch<any>(logoutAsync.request({ shouldResetToken: false }));
      } else {
        // TODO we should implement re-try here, as in provider app
        store.dispatch<any>(logoutAsync.request({ shouldResetToken: false }));
      }
    },
    updateAccessToken: () => waitForAccessTokenUpdate(store),
  };
};
